var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$store.getters.allAuthUser
      ? _c(
          "div",
          {
            staticClass: "process_list",
            staticStyle: {
              "background-color": "#fff5e6",
              "border-color": "#ffebcc",
              padding: "5px",
              "margin-bottom": "10px",
              display: "flex",
              "justify-content": "flex-start",
              "align-items": "flex-start"
            }
          },
          [
            _c(
              "p",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "#f8b762", margin: "0 10px" }
                }),
                _c("span", { staticClass: "process_list_num" }, [_vm._v("1")]),
                _vm.isInDingTalk
                  ? _c("span", [_vm._v("创建审批流程")])
                  : _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.junziqian.com/help_detail-10.html",
                          target: "_blank"
                        }
                      },
                      [_vm._v("创建审批流程")]
                    ),
                _c("i", { staticClass: "el-icon-right icon_size" }),
                _c("span", { staticClass: "process_list_num" }, [_vm._v("2")]),
                _c("span", [_vm._v("设置审批流程使用范围")])
              ]
            )
          ]
        )
      : _vm._e(),
    !_vm.isInDingTalk
      ? _c("div", { staticClass: "main-warp" }, [_c("contract-approval")], 1)
      : _vm._e(),
    _vm.isInDingTalk ? _c("div", [_c("dingFlow")], 1) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-759d4642", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759d4642","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/flow.vue
// module id = EgDW
// module chunks = 7 55